import * as React from "react";


export function Spinner() {
    return <div className="cssloader" title="Vent litt..."/>
}